'use client'

import { useParams, usePathname } from 'next/navigation'
import { lazy, Suspense } from 'react'

const WorkspaceSoftphoneWrapper = lazy(() =>
  import('./softphone-wrapper').then(({ SoftphoneWrapper }) => ({ default: SoftphoneWrapper }))
)

export function isWorkspaceApplicationPath(pathname: string, workspaceId: string) {
  const segments = pathname.split('/').filter(Boolean)
  const [firstSegment] = segments
  if (!firstSegment) {
    return false
  }

  let decodedFirstSegment: string
  try {
    decodedFirstSegment = decodeURIComponent(firstSegment)
  } catch {
    return false
  }

  return decodedFirstSegment === workspaceId && segments[1] !== 'u'
}

function CurrentRouteSoftphoneWrapper({ children }: { children: React.ReactNode }) {
  const params = useParams<{ workspaceId?: string | string[] }>()
  const pathname = usePathname()
  const workspaceId = typeof params.workspaceId === 'string' ? params.workspaceId : null

  if (!(workspaceId && isWorkspaceApplicationPath(pathname, workspaceId))) {
    return <>{children}</>
  }

  return <WorkspaceSoftphoneWrapper workspaceId={workspaceId}>{children}</WorkspaceSoftphoneWrapper>
}

export function RootSoftphoneWrapper({ children }: { children: React.ReactNode }) {
  return (
    <Suspense fallback={children}>
      <CurrentRouteSoftphoneWrapper>{children}</CurrentRouteSoftphoneWrapper>
    </Suspense>
  )
}
